<mat-form-field  [floatLabel]="placeholder ? 'always' : 'auto'">
  <mat-label>{{label}}</mat-label>
  <input matInput type="number" [formControl]="ctrl" placeholder="{{placeholder || label}}">
  <span matSuffix>px</span>
</mat-form-field>
